<div [ngClass]="Theme">
    <ng-content select="[foo-content]"></ng-content>
</div>